import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-up,arrow-top"} maskId="square-filled-radius-0-stroke-1-IconArrowUp"><path fillRule="evenodd" clipRule="evenodd" d="M12.0001 2.58578L19.4144 10L18.0002 11.4142L13.0001 6.41421V21H11.0001V6.41422L6.00015 11.4142L4.58594 10L12.0001 2.58578Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowUp;
